import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

const deleteZoomMeeting = async ({ meetingId }: { meetingId: string }) => {
  const res = await fetchOrchidAPI(
    `/api/users/v1/zoom/delete_meeting/${meetingId}`,
    {
      method: "DELETE",
    },
  );

  if (!res.ok) {
    const responseText = await res.text();
    throw new Error(getErrorDetail(responseText));
  }

  return;
};

export default deleteZoomMeeting;
